<script>
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import UserSelect from '../UI/Form/UserSelect.vue'

export default {
  components: { FormCreator, FieldCreator, ModalDialog, UserSelect },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    id: { type: Number, required: true },
    actorId: { type: Number, required: true },
    financeId: { type: Number, required: true },
    type: { type: String, required: true },
    context: { type: String, required: true, validator: (value) => ['simulation', 'contract'].includes(value) },
  },

  data() {
    return {
      actor: {},
      entityId: null,
      def: {},
      loadField: false,
      loadForm: false,
      sending: false,
      formData: null,
    }
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    setElement(def, obj) {
      this.def = def
      this.actor = obj
      this.entityId = obj.entity?.id
    },
    isSending(bool) {
      this.sending = bool
    },
    isLoading(bool) {
      this.$emit('is-loading', bool)
    },
    showForm() {
      this.loadForm = true
    },
    openModal() {
      this.$refs['actor' + this.actorId].open()
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.$refs['actor' + this.actorId].close(false)
    },
    setDatas(json) {
      this.$emit('actor-sent', json)
      this.closeModal()
    },
  },

  computed: {
    canAddOrModifyDirector() {
      return this.actor.director === null || this.hasRole('ROLE_ADD_MODIFY_DIRECTOR')
    },
    contractId() {
      return this.context === 'contract' ? this.id : null
    },
    simulationId() {
      return this.context === 'simulation' ? this.id : null
    },
  },
}
</script>
<template>
  <ModalDialog
    :id="'actor' + actorId"
    :ref="'actor' + actorId"
    class-modal-dialog="modal-lg"
    @icon-close="closeModal"
    e2e-modal="actor"
  >
    <template v-if="loadField" #body>
      <FieldCreator
        :form-data="formData"
        name="director"
        form-ref="myformactor"
        domain="actor"
        :add-director="canAddOrModifyDirector"
        label-left
        :entity-id="entityId"
        :director-id="actor.director ? actor.director.id : null"
        :finance-id="financeId"
      ></FieldCreator>
      <FieldCreator
        :form-data="formData"
        name="signer"
        form-ref="myformactor"
        domain="actor"
        add-user
        :object-id="id"
        :user-id="actor.signer ? actor.signer.id : null"
        :entity-id="entityId"
        :client-id="actor.entity ? actor.entity.id : null"
        :finance-id="financeId"
        label-left
        :specific-label="type"
      ></FieldCreator>
      <FieldCreator
        v-if="type === 'CLIENT'"
        :form-data="formData"
        name="executiveSigner"
        form-ref="myformactor"
        domain="actor"
        add-user
        :object-id="id"
        :user-id="actor.executiveSigner ? actor.executiveSigner.id : null"
        :entity-id="entityId"
        :client-id="actor.entity ? actor.entity.id : null"
        :finance-id="financeId"
        label-left
        :specific-label="type"
      ></FieldCreator>
      <FieldCreator
        v-if="['CLIENT', 'SURRENDER'].includes(type) && isTheme('lbp')"
        :form-data="formData"
        name="approvers"
        form-ref="myformactor"
        domain="actor"
        add-user
        :object-id="id"
        :entity-id="entityId"
        :client-id="actor.entity ? actor.entity.id : null"
        :finance-id="financeId"
        label-left
        :specific-label="type"
        multiple-choice
        select-multiple
      ></FieldCreator>
      <FieldCreator
        v-if="type === 'SURRENDER' && isTheme('lbp')"
        :form-data="formData"
        name="surrender"
        form-ref="myformactor"
        domain="contract"
        add-user
        :object-id="id"
        :entity-id="entityId"
        :client-id="actor.entity ? actor.entity.id : null"
        :finance-id="financeId"
        label-left
        :specific-label="type"
        multiple-choice
        select-multiple
      ></FieldCreator>
      <FieldCreator
        :form-data="formData"
        name="accountContact"
        form-ref="myformactor"
        domain="actor"
        add-user
        :object-id="id"
        :user-id="actor.accountContact ? actor.accountContact.id : null"
        :entity-id="entityId"
        :client-id="actor.entity ? actor.entity.id : null"
        :finance-id="financeId"
        label-left
        :specific-label="type"
      ></FieldCreator>
      <UserSelect
        :form-data="formData"
        :input-id="`billingContacts-formsetup`"
        :client-id="actor.entity?.id"
        :contract-id="contractId"
        :simulation-id="simulationId"
        :entity-id="actor.entity?.id"
        :finance-id="financeId"
        :specific-label="type"
        name="billingContacts"
        form-ref="formsetup"
        domain="actor"
        user-entity
        label-wrapper-classes="col-xl-4 col-md-12 d-flex justify-content-between"
        input-wrapper-classes="col-xl-8 col-md-12"
        multiple
      />
      <FieldCreator
        :form-data="formData"
        name="billingAddress"
        form-ref="myformactor"
        :finance-id="financeId"
        domain="actor"
        label-left
      ></FieldCreator>
      <FieldCreator
        :form-data="formData"
        name="billingCode"
        form-ref="myformactor"
        :finance-id="financeId"
        domain="actor"
        label-property="code"
        value-property="id"
        label-left
      ></FieldCreator>
      <FieldCreator
        :form-data="formData"
        name="shareRent"
        form-ref="myformactor"
        domain="actor"
        label-left
      ></FieldCreator>
    </template>
    <template #footer>
      <div class="mt-3">
        <FormCreator
          v-if="loadForm"
          @update-data="updateData"
          ref="myformactor"
          endpoint="actors"
          method="patch"
          :id="actorId"
          :params="{ financeId: financeId, id: actorId }"
          :in-modal="true"
          class-to-add="btn-lg"
          @modal-build="openModal"
          @form-build="setBuild"
          @element-build="setElement"
          @form-return="setDatas"
          @is-sending="isSending"
          @is-loading="isLoading"
        >
          <div v-if="sending" class="text-center">
            <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else e2e-button="actorSave">
            {{ $t('button.save') }}
          </div>
        </FormCreator>

        <button type="button" class="btn btn-lg btn-info ml-2" @click="closeModal" e2e-button="close">
          {{ $t('main.close') }}
        </button>
      </div>
    </template>
  </ModalDialog>
</template>
